<template>
<!-- 资源管理 -->
  <div>
    <navigation-bar></navigation-bar>
    <div class="main">
      <el-row>
        <!-- 左侧导航栏 -->
        <el-col :span="4">
          <div class="sidebar">
            <div class="sidebar_title">资源管理</div>
            <div class="sidebar_item" :class="{active:true}">
              已购资源
            </div>
          </div>
        </el-col>
        <!-- 内容 -->
        <el-col :span="16">
          <div class="content">
            <div class="con_header">
              <span class="con_title">已购资源</span>
              <div class="header_right">
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width:200px;margin-right:20px">
                </el-date-picker>
                <el-input v-model="searchValue" @keyup.enter.native="getData" placeholder="请输入资源名称" size="small" style="width:250px">
                  <template #suffix>
                      <i class="el-input__icon el-icon-search" @click="getData"></i>
                  </template>
                </el-input>
              </div>
            </div>
            <!-- selection_list -->
            <div class="selection_list">
              <div class="sel_title">使用状态</div>
              <div class="sel_item" :class="{current: useStatus==item.value}" v-for="(item,index) in useStatusList" :key="index" @click="selectUseStatus(item.value)">
                {{item.name}}
              </div>
            </div>
            <!-- table -->
            <div class="table">
              <el-table
                :data="resourceTableData"
                :header-cell-style="{background:'rgba(233, 239, 255, 1)',color:'#2A2A2A'}"
                style="width: 100%">
                <el-table-column
                  label="合同ID"
                  min-width="100">
                  <template slot-scope="scope">
                    {{scope.row.contractId}}
                    <el-popover
                      popper-class="copy_hint"
                      placement="right"
                      width="40"
                      trigger="click">
                      <div>复制成功</div>
                      <i slot="reference" class="el-icon-copy-document copy_btn" @click="copyNumber(scope.row.contractId)"></i>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="productName"
                  label="产品名称">
                </el-table-column>
                <el-table-column
                  prop="runStatus"
                  label="状态">
                  <span class="state"><i class="el-icon-success"></i>运行中</span>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="创建时间">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <div class="action_buttons"><i @click="restart(scope.row)">重启</i>|<i @click="jump">权限管理</i></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- pagination -->
            <div class="pagination">
              <el-pagination
                v-if="total > 0"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </div>
            <!-- dialog -->
            <el-dialog :visible.sync="dialogVisible" center>
              <template slot="title">
                  <div class="dialog_title">重启</div>
              </template>
              <div class="dialog_text">已选实例:</div>
              <div class="table">
                <el-table
                  :data="dialogTableData"
                  append-to-body
                  :header-cell-style="{background:'rgba(233, 239, 255, 1)',color:'#2A2A2A','text-align':'center'}"
                  :cell-style="{'text-align':'center'}">
                  <el-table-column
                    label="合同ID">
                    <template slot-scope="scope">
                      {{scope.row.contractId}}
                      <el-popover
                        popper-class="copy_hint"
                        placement="right"
                        width="40"
                        trigger="click">
                        <div>复制成功</div>
                        <i slot="reference" class="el-icon-copy-document copy_btn" @click="copyNumber(scope.row.contractId)"></i>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="productName"
                    label="产品名称">
                  </el-table-column>
                  <el-table-column
                    prop="runStatus"
                    label="状态">
                    <span class="state"><i class="el-icon-success"></i>运行中</span>
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="创建时间">
                  </el-table-column>
                </el-table>
              </div>
              <div class="dialog_prompt"><i class="el-icon-warning-outline"></i>实例重启期间服务不可用切操作无法撤销，请谨慎操作</div>
              <span slot="footer" class="dialog-footer">
                <button size="medium" class="confirm_button" @click="dialogVisible = false">确认重启</button>
                <button size="medium" class="cancel_button" @click="dialogVisible = false">取消</button>
              </span>
            </el-dialog>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryResourceByConditions } from '@/api/console/resourceManagement.js'
import NavigationBar from '../../../components/console/navigationBar.vue'
import token from '@/utils/token.js'
export default {
  components: {
    NavigationBar
  },
  data() {
    return {
      searchValue: '',//搜索值
      dateRange: '',//日期范围
      useStatus: '',//使用状态
      useStatusList: [{
        name: '全部',
        value: ''
      },{
        name: '运行中',
        value: '1'
      },{
        name: '已过期',
        value: '2'
      },{
        name: '已冻结',
        value: '3'
      }],
      resourceTableData: [{}],
      pageSize: 5,
      currentPage:1,
      total: 0,
      // dialog
      dialogVisible: false,
      dialogTableData: [],
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    //日期选择器添加右侧图标
     document.getElementsByClassName('el-range__close-icon')[0].className += ' el-icon-date';
  },
  methods: {
    getData() {
      let param = {
        name: this.searchValue,
        nowPage: this.currentPage,
        pageSize: this.pageSize,
        runStatus: this.useStatus,
        userId: token.getUser().id
      }
      queryResourceByConditions(param).then(res => {
        // console.log('资源列表', res);
        this.resourceTableData = res.data.list;
        this.total = res.data.list.length;
      })
    },
    //选择使用状态
    selectUseStatus(val) {
      this.useStatus = val;
      this.getData();
    },
    //复制订单号
    copyNumber(text) {
      var input = document.createElement("input");
      input.value = text; // 修改文本框的内容
      document.body.appendChild(input);
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      document.body.removeChild(input)
    },
    //重启
    restart(row) {
      this.dialogVisible = true;
      this.dialogTableData = [];
      this.dialogTableData.push(row)
    },
    //权限管理（跳转）
    jump() {
      window.open('http://121.37.136.73:50000/#/login?redirect=%2Frabc%2Fdept%2Findex','_blank')
    },
    //每页显示条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    //当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
  }
}
</script>

<style lang="scss" scoped="scoped">
.main {
  margin-top: 80px;
  .sidebar {
    width: 80%;
    height: 1200px;
    color: #4F4F4F;
    border-right: 1px solid #E5E5E5;
    .sidebar_title {
        height: 79px;
        border-bottom: 1px solid #E5E5E5;
        text-align: center;
        line-height: 79px;
    }
    .sidebar_item {
      height: 47px;
      font-size: 14px;
      text-align: center;
      line-height: 47px;
    }
    .active {
      background-color: #F8F9FF;
      color: #537EEE;
      border-right: 4px solid #537EEE;
    }
    .sidebar_item:hover {
      cursor: pointer;
      background-color: #F8F9FF;
      color: #537EEE;
    }
  }
  .content {
    width: 100%;
    padding: 20px;
    margin-top: 20px;
    border: 1px solid #E5E5E5;
    .con_header {
      overflow: hidden;
      .con_title {
        color: #4F4F4F;
      }
      .header_right {
        float: right;
        /deep/.el-range__icon {
          display: none;
        }
      }
    }
    .selection_list {
      height: 32px;
      margin-top: 20px;
      font-size: 12px;
      line-height: 32px;
      div {
        float: left;
      }
      .sel_title {
        margin-right: 20px;
        color: #4F4F4F;
      }
      .sel_item {
        width: 157px;
        margin-right: 3px;
        background-color: #E9EFFF;
        color: #2A2A2A;
        text-align: center;
      }
      .sel_item:hover {
        cursor: pointer;
      }
      .current {
        background-color: #5984EC;
        color: #fff;
      }
    }
    .table {
      border: 1px solid #E5E5E5;
      border-top: none;
      border-bottom: none;
      .copy_btn {
        margin-left: 5px;
      }
      .copy_btn:hover {
        cursor: pointer;
      }
      .state {
        color: #039F00;
      }
      .action_buttons {
        color: #E5E5E5;
        i {
          margin: 0 8px;
          font-style: normal;
          color: #507DF1;
        }
        i:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .el-table {
      margin-top: 20px;
      font-size: 12px;
      /deep/ th {
          padding: 4px;
          font-weight: 400;
      }
      /deep/ td {
          padding: 10px;
      }
      /deep/ .cell {
        overflow: visible;
      }
    }
    .pagination {
      overflow: hidden;
      margin-top: 20px;
      .el-pagination {
        float: right;
      }
    }
    // dialog
    .el-dialog {
      .dialog_title {
        height: 68px;
        background-color: #E9EFFF;
        font-size: 20px;
        color: #507DF1;
        text-align: center;
        line-height: 68px;
      }
      .dialog_text {
        margin-bottom: 20px;
      }
      .dialog_prompt {
        margin-top: 30px;
        font-size: 12px;
        color: #4F4F4F;
        text-align: center;
        i {
          padding-right: 5px;
          font-size: 16px;
          color: #C12B31;
        }
      }
      .state {
        color: #039F00;
      }
      .confirm_button {
        width: 30%;
        height: 32px;
        margin-right: 8px;
        border: none;
        background-color: #C12B31;
        font-size: 14px;
        color: #fff;
      }
      .confirm_button:hover {
        cursor: pointer;
      }
      .cancel_button {
        width: 30%;
        height: 30px;
        border: 1px solid #E5E5E5;
        background-color: #fff;
        font-size: 14px;
        color: #4F4F4F;
      }
      .cancel_button:hover {
        cursor: pointer;
      }
    }
  }
}
</style>

<style lang="scss">
  .el-dialog__header {
    padding: 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #537EEE;
  }
  .copy_hint {
    min-width: 60px;
    padding: 6px 12px;
    background-color: #EAFFEA;
    color: #6DD747;
  }
</style>